import React, { Component } from 'react';
import styled from 'styled-components';
import { PrestoAppTheme, PrestoAppComponents, PrestoAppUtils } from 'presto-mini-apps-lib';
import PageWrapper from '../../components/PageWrapper';
import {
    RedirectDelay,
    PaymentType,
    ContainerWidth,
    ButtonHeight,
    beautifyDate
} from '../../constants/appState';
import {
    term_amount,
    term_points,
    term_merchant,
    term_details,
    term_payWith,
    term_refNum,
    term_date,
    term_cardDisplayName,
    TopUpMessages,
    phrase_topUpSuccessText,
    title_topUpSuccess,
    term_ok
} from '../../constants/text';
import connectPage from '../../scenes/Main/index';
import Routes from '../../constants/routes';
import MessagePanel from '../../components/MessagePanel/index';
import { appService } from '../../services';


class TopUpSuccess extends Component {
    pageName;

    constructor(props) {
        super(props);

        this.pageName = Routes.TOPUP_SUCCESS;
        //this.goBackTimeout = null;

        this.state = {
            detailList: {
                [term_amount]: 0,
                [term_merchant]: '',
                [term_details]: '',
                [term_payWith]: '',
                [term_date]: '',
                [term_refNum]: '',
                [term_cardDisplayName]: '',
            },
            paymentSuccess: true,
        }
    }

    componentDidMount() {
        const { mainProps } = this.props;
        const topUpData = mainProps.appState.topUpData;

        const paymentSuccess = topUpData.paymentStatus === "Authorised";
        if (paymentSuccess) {
            this.setState({
                detailList: {
                    [term_amount]: mainProps.appState.curCode.currency + PrestoAppUtils.convertToCurrency(+topUpData.amount / 100),
                    [term_merchant]: topUpData.merchantInfo.name,
                    [term_details]: topUpData.displayDesc,
                    [term_payWith]: topUpData.payments,
                    [term_date]: beautifyDate(topUpData.authorisedDate),
                    [term_refNum]: topUpData.paymentRefNum,
                    [term_cardDisplayName]: topUpData.cardDisplayName,
                },
                paymentSuccess: paymentSuccess
            });
        } else {
            this.setState({
                detailList: {
                    [term_details]: topUpData.displayDesc,
                    [term_amount]: mainProps.appState.curCode.currency + PrestoAppUtils.convertToCurrency(0),
                    [term_merchant]: topUpData.merchantInfo.name,
                    [term_date]: beautifyDate(topUpData.authorisedDate),
                    [term_refNum]: topUpData.paymentRefNum
                },
                paymentSuccess: paymentSuccess
            });
        }

        //this.goBackTimeout = setTimeout(() => this.goBackHome(), RedirectDelay);
    }

    componentWillUnmount() {
        //clearTimeout(this.goBackTimeout);
    }

    goBackHome = () => {
        const { actionHandler, mainProps } = this.props;
        const formValue = mainProps.appState.loginData;

        actionHandler.setIsLoading(true);

        appService.apiLogin({
            paymentCode: window.PrestoPayObj.paymentCode,
            authCode: window.PrestoPayObj.authCode,
            loginMethod: formValue.loginMethod,
            mobileNum: formValue.mobile.replace(/^0+/, ''),
            mobileCountryCode: (!!formValue.email && formValue.email !== '' ? '' : formValue.mobileCountryCode),
            email: formValue.email,
            password: formValue.password,
            refresh: true,
            onSuccess: this.onLoginSuccessHandler,
            onError: this.onLoginFailedHandler
        });
    };

    onLoginSuccessHandler = (resp) => {
        const { actionHandler, mainProps } = this.props;
        const { paymentData } = mainProps.appState;

        actionHandler.setIsLoading(false);

        if (!!resp.success) {
            actionHandler.updatePaymentData({
                ...resp.data,
                loyaltyPaymentMethod: paymentData.loyaltyPaymentMethod,
                formValue: paymentData.formValue,
            });
            actionHandler.changePageHandler(Routes.PAYMENT);
        }
    };

    onLoginFailedHandler = (data) => {
        const { actionHandler } = this.props;
        actionHandler.setIsLoading(false);
    };

    htmlDecode = (input) => {
        const e = document.createElement('textarea');
        e.innerHTML = input;
        // handle case of empty input
        return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
    };

    render() {
        const { mainProps } = this.props;
        const { detailList, paymentSuccess } = this.state;

        const topUpData = mainProps.appState.topUpData;

        const paymentList = detailList[term_payWith];

        let sortedPaymentList = [];
        if (paymentList !== undefined && paymentList !== '') {
            if (paymentList.length > 1) {
                // NOTE: get Wallet item
                let walletItem = paymentList.filter(item => (item.paymentMethod === PaymentType.PRESTOWALLET));

                // NOTE: get CashBack item
                let creditItem = paymentList.filter(item => (item.paymentMethod === PaymentType.CASHBACK));

                // NOTE: others
                let otherItems = paymentList.filter(item => (
                    item.paymentMethod !== PaymentType.PRESTOWALLET &&
                    item.paymentMethod !== PaymentType.CASHBACK)
                );

                sortedPaymentList = [...otherItems, ...walletItem, ...creditItem];
            } else {
                sortedPaymentList = paymentList;
            }
        }

        return (
            <React.Fragment>
                <PageWrapper>
                    <MessagePanel
                        className={paymentSuccess ? "page-success" : "page-error"}
                        title={paymentSuccess ? title_topUpSuccess : TopUpMessages[topUpData.paymentStatus].title}
                        message={paymentSuccess ? phrase_topUpSuccessText(detailList[term_amount]) : TopUpMessages[topUpData.paymentStatus].message}
                        isError={!paymentSuccess}
                        isTopUp={true}
                    >
                        <SuccessContentWrapper>
                            <div className="transaction-details">
                                {Object.keys(detailList).map((key, index) => {
                                    if (key !== term_amount && key !== term_merchant && key !== term_cardDisplayName) {
                                        return (
                                            <DetailRow key={index} className="details-row">
                                                <div className="label">{key}</div>
                                                <div className="value">{
                                                    // (Array.isArray( detailList[key] ) ? (
                                                    (key === term_payWith ? (
                                                        // NOTE: is payment list
                                                        sortedPaymentList.map((item, key) => {
                                                            return (
                                                                <div key={key}>{(
                                                                    (item.paymentMethod === PaymentType.CARD &&
                                                                        !!detailList[term_cardDisplayName] &&
                                                                        detailList[term_cardDisplayName] !== '')
                                                                        ? detailList[term_cardDisplayName]
                                                                        : item.paymentMethodLabel !== null && item.paymentMethodLabel !== '' ? this.htmlDecode(item.paymentMethodLabel)
                                                                            : item.paymentMethod
                                                                ) + ((item.points && item.points > 0) ?
                                                                    '(' + item.points + ' ' + item.unit + ') (' + mainProps.appState.curCode.currency + PrestoAppUtils.convertToCurrency(+item.amount / 100) + ')'
                                                                    : '(' + mainProps.appState.curCode.currency + PrestoAppUtils.convertToCurrency(+item.amount / 100) + ')')
                                                                }
                                                                </div>
                                                            )
                                                        })
                                                    ) : detailList[key])
                                                }</div>
                                            </DetailRow>
                                        );
                                    }
                                })}
                            </div>
                        </SuccessContentWrapper>
                        <SuccessActionWrapper>
                            <div className="action-area">
                                <PrestoAppComponents.Button
                                    height={ButtonHeight+'px'}
                                    className="login-button"
                                    onClick={this.goBackHome}
                                >{term_ok}</PrestoAppComponents.Button>
                            </div>
                        </SuccessActionWrapper>
                    </MessagePanel>
                </PageWrapper>
            </React.Fragment>
        );
    }
}

export default connectPage(TopUpSuccess);

const DetailRow = styled.div`
    display: flex;
    padding: ${PrestoAppTheme.layout.commonGap} 0;
    border-bottom: 1px solid ${PrestoAppTheme.colors.baseSnowDark};
    justify-content: space-between;

    &:last-child {
        border-bottom: 0;
    }

    & > .label { 
        width: 70px;
        font-wight: 300; 
        color: ${PrestoAppTheme.colors.baseGreyDark};
    }

    & > .value { 
        width: calc(100% - 70px);
        text-align: right;
        font-weight: 400; 
        word-break: break-word;
    }
`;

const SuccessContentWrapper = styled.div`
    & .transaction-details {
        padding: 0 ${PrestoAppTheme.layout.largeGap};
    }
`;

const SuccessActionWrapper = styled.div`
    position: relative;
    width: calc(100% - 2rem);
    max-width: ${ContainerWidth}px;
    margin: ${PrestoAppTheme.layout.commonGap} auto;

    & .action-area {
        padding: ${PrestoAppTheme.layout.commonGap} 0;
    }
`;